import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const EngagementChart = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground mb-2">{payload?.[0]?.payload?.month}</p>
          <div className="space-y-1">
            <p className="text-xs text-primary">
              Engagement: <span className="font-semibold data-text">{payload?.[0]?.value}%</span>
            </p>
            <p className="text-xs text-secondary">
              Conversions: <span className="font-semibold data-text">{payload?.[1]?.value}</span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
            Campaign Performance
          </h3>
          <p className="text-sm text-muted-foreground">
            Monthly engagement and conversion trends
          </p>
        </div>
        <div className="flex gap-2">
          <button className="px-3 py-1.5 rounded-lg text-xs font-medium bg-primary/10 text-primary">
            6 Months
          </button>
          <button className="px-3 py-1.5 rounded-lg text-xs font-medium text-muted-foreground hover:bg-muted">
            1 Year
          </button>
        </div>
      </div>

      <div className="w-full h-64 md:h-80" aria-label="Campaign Performance Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="month"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: '12px', paddingTop: '20px' }}
              iconType="circle"
            />
            <Bar
              dataKey="engagement"
              fill="var(--color-primary)"
              radius={[8, 8, 0, 0]}
              name="Engagement Rate (%)"
            />
            <Bar
              dataKey="conversions"
              fill="var(--color-secondary)"
              radius={[8, 8, 0, 0]}
              name="Conversions"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EngagementChart;